import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./FormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Sharing = Loadable({
  loader: () => import('./AppSharingPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Theme = Loadable({
  loader: () => import('./AppThemePage'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./AppsList'),
  loading: () => null,
});
